// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedRgbChannelsRed_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0 0H16V16H0V0Z" fill="#ED5353"/>
  <path d="M12.0898 12.4277H9.91602L8.60938 10.2656C8.51172 10.1016 8.41797 9.95508 8.32812 9.82617C8.23828 9.69727 8.14648 9.58789 8.05273 9.49805C7.96289 9.4043 7.86719 9.33398 7.76562 9.28711C7.66797 9.23633 7.56055 9.21094 7.44336 9.21094H6.93359V12.4277H5.04102V4.02539H8.04102C10.0801 4.02539 11.0996 4.78711 11.0996 6.31055C11.0996 6.60352 11.0547 6.875 10.9648 7.125C10.875 7.37109 10.748 7.59375 10.584 7.79297C10.4199 7.99219 10.2207 8.16406 9.98633 8.30859C9.75586 8.45312 9.49805 8.56641 9.21289 8.64844V8.67188C9.33789 8.71094 9.45898 8.77539 9.57617 8.86523C9.69336 8.95117 9.80664 9.05273 9.91602 9.16992C10.0254 9.28711 10.1289 9.41406 10.2266 9.55078C10.3281 9.68359 10.4199 9.81445 10.502 9.94336L12.0898 12.4277ZM6.93359 5.44336V7.78125H7.75391C8.16016 7.78125 8.48633 7.66406 8.73242 7.42969C8.98242 7.19141 9.10742 6.89648 9.10742 6.54492C9.10742 5.81055 8.66797 5.44336 7.78906 5.44336H6.93359Z" class="svg-fg"/>
</svg>
`;
/**
 * IconMedRgbChannelsRed is a generated icon component.
 */
let IconMedRgbChannelsRed = IconMedRgbChannelsRed_1 = class IconMedRgbChannelsRed extends IconBaseElement {
    render() {
        return html `${IconMedRgbChannelsRed_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedRgbChannelsRed.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconMedRgbChannelsRed = IconMedRgbChannelsRed_1 = __decorate([
    customElement('zui-icon-med-rgb-channels-red')
], IconMedRgbChannelsRed);
export { IconMedRgbChannelsRed };
